module.exports = __webpack_public_path__ + "img/talabash-mini.eec69fda.png";